import React, { Component, Fragment } from 'react'
import * as JsSearch from 'js-search'
import { MDBRow, MDBCol, MDBContainer } from 'mdbreact'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faSearch } from '@fortawesome/pro-regular-svg-icons'
import BlogAllItems from './blogAllItems'
import CustomLink from './CustomLink'
import moment from 'moment'

class ClientSearch extends Component {
  state = {
    isLoading: true,
    searchResults: [],
    search: null,
    isError: false,
    indexByTemplate: false,
    indexByName: false,
    indexByTitle: false,
    indexBySubtitle: false,
    indexByDate: false,
    indexByCategory: false,
    indexByPlatform: false,
    indexByHeadline: false,
    indexByBody: false,
    indexBySection: false,
    termFrequency: true,
    removeStopWords: false,
    searchQuery: '',
    selectedStrategy: '',
    selectedSanitizer: '',
  }
  /**
   * React lifecycle method that will inject the data into the state.
   */
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.search === null) {
      const { engine } = nextProps
      return {
        indexByTemplate: engine.TemplateIndex,
        indexByName: engine.NameIndex,
        indexByTitle: engine.TitleIndex,
        indexBySubtitle: engine.SubtitleIndex,
        indexByDate: engine.DateIndex,
        indexByCategory: engine.CategoryIndex,
        indexByPlatform: engine.PlatformIndex,
        indexByHeadline: engine.HeadlineIndex,
        indexByBody: engine.BodyIndex,
        indexBySection: engine.SectionIndex,
        termFrequency: engine.SearchByTerm,
        selectedSanitizer: engine.searchSanitizer,
        selectedStrategy: engine.indexStrategy,
      }
    }
    return null
  }
  async componentDidMount() {
    this.rebuildIndex()
    this.searchInput.focus()

    let storedQuery = ""
    if (location.pathname.indexOf("/search/") == -1) {
      storedQuery = sessionStorage.getItem('blogQuery')
    } else {
      storedQuery = sessionStorage.getItem('searchQuery')
    }
    if (storedQuery) {
      this.setState({ searchQuery: storedQuery }, () => {
        this.performSearch(storedQuery)
      })
    }
  }

  /**
   * rebuilds the overall index based on the options
   */
  rebuildIndex = () => {
    const {
      selectedStrategy,
      selectedSanitizer,
      removeStopWords,
      termFrequency,
      indexByTemplate,
      indexByName,
      indexByTitle,
      indexBySubtitle,
      indexByDate,
      indexByCategory,
      indexByPlatform,
      indexByHeadline,
      indexByBody,
      indexBySection,
    } = this.state
    const { content } = this.props

    const dataToSearch = new JsSearch.Search(['id'])

    if (removeStopWords) {
      dataToSearch.tokenizer = new JsSearch.StopWordsTokenizer(
        dataToSearch.tokenizer
      )
    }
    /**
     * defines an indexing strategy for the data
     * read more about it here https://github.com/bvaughn/js-search#configuring-the-index-strategy
     */
    if (selectedStrategy === 'All') {
      dataToSearch.indexStrategy = new JsSearch.AllSubstringsIndexStrategy()
    }
    if (selectedStrategy === 'Exact match') {
      dataToSearch.indexStrategy = new JsSearch.ExactWordIndexStrategy()
    }
    if (selectedStrategy === 'Prefix match') {
      dataToSearch.indexStrategy = new JsSearch.PrefixIndexStrategy()
    }

    /**
     * defines the sanitizer for the search
     * to prevent some of the words from being excluded
     */
    selectedSanitizer === 'Case Sensitive'
      ? (dataToSearch.sanitizer = new JsSearch.CaseSensitiveSanitizer())
      : (dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer())
    termFrequency === true
      ? (dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex(['id']))
      : (dataToSearch.searchIndex = new JsSearch.UnorderedSearchIndex())

    // sets the index attribute for the data
    if (indexByTemplate) {
      dataToSearch.addIndex(['template'])
    }
    // sets the index attribute for the data
    if (indexByName) {
      dataToSearch.addIndex(['name'])
    }
    // sets the index attribute for the data
    if (indexByTitle) {
      dataToSearch.addIndex(['title'])
    }
    // sets the index attribute for the data
    if (indexBySubtitle) {
      dataToSearch.addIndex(['subtitle'])
    }
    // sets the index attribute for the data
    if (indexByDate) {
      dataToSearch.addIndex(['date'])
    }
    // sets the index attribute for the data
    if (indexByCategory) {
      dataToSearch.addIndex(['category'])
    }
    // sets the index attribute for the data
    if (indexByPlatform) {
      dataToSearch.addIndex(['platform'])
    }
    // sets the index attribute for the data
    if (indexByHeadline) {
      dataToSearch.addIndex(['headline'])
    }
    // sets the index attribute for the data
    if (indexByBody) {
      dataToSearch.addIndex(['body'])
    }
    // sets the index attribute for the data
    if (indexBySection) {
      dataToSearch.addIndex(['section'])
    }

    dataToSearch.addDocuments(content) // adds the data to be searched

    this.setState({ search: dataToSearch, isLoading: false })
  }


  componentDidUpdate(prevProps, prevState) {
    // save the blog / search query to session storage if changed
    if (this.state.searchQuery !== prevState.searchQuery) {
      if (location.pathname.indexOf("/search/") == -1) {
          sessionStorage.setItem('blogQuery', this.state.searchQuery)
      } else {
        sessionStorage.setItem('searchQuery', this.state.searchQuery)
      }
    }  else {
      if (this.props.reset !== prevProps.reset) {
        // clear the blog query from session storage due to tag button click
        sessionStorage.setItem('blogQuery', "")
        this.setState({ searchQuery: "" })
        this.performSearch("")
      }
    }
  }

  /**
   * used when returning to this page where the  
   * search query previously had a value
   */
  performSearch = (query) => {  
    const queryResult = this.state.search.search(query) 
    this.setState({ searchResults: queryResult })
  }

  /**
   * handles the input change and perform a search with js-search
   * in which the results will be added to the state
   */
  searchData = e => {
    const { search } = this.state
    const queryResult = search.search(e.target.value)
    this.setState({ searchQuery: e.target.value, searchResults: queryResult })
  }
  handleSubmit = e => {
    e.preventDefault()
  }
  handleClick = () => {
    this.setState({ searchQuery: "", searchResults: [] })
  }
  render() {
    const { searchResults, searchQuery } = this.state
    const queryResults = searchQuery === '' ? searchResults : this.props.context === "blog" ? searchResults.sort((a, b) => a.date == b.date ? 0 : a.date > b.date ? -1 : 1) : searchResults
    return (
      <MDBContainer>
        <MDBRow>
          <MDBCol md="12" lg="4" className="pt-3 px-0" >
            {!!this.props.tagHeader ?
              <p className="font-alt font-w-300 letter-spacing-1 text-medium"><CustomLink link="/blog/" className="effect">Blog</CustomLink> / {(this.props.tagHeader && this.props.tagHeader !== "*") ? <CustomLink link="/blog/tags/" className="effect">Tags</CustomLink> : "Tags"} {(this.props.tagHeader && this.props.tagHeader !== "*") ? `/ ${this.props.tagHeader}` : ""}</p>
            : 
              <p className="font-alt font-w-300 letter-spacing-1 text-medium">&nbsp;</p>
            }
          </MDBCol>
          

          <MDBCol md="12" lg="4" className="d-flex justify-content-left">
            <form
              onSubmit={this.handleSubmit}
              className="form-inline mt-2 mb-1 justify-content-center"
            >
              <FontAwesomeIcon icon={faSearch} />
              <input
                className="form-control form-control-lg ml-3 w-75 text-xs-large text-large search-box"
                type="text"
                ref={input => { this.searchInput = input }}
                id="Search"
                value={searchQuery}
                onChange={this.searchData}
                placeholder={this.props.context === "blog" ? "Search blogs..." : "Please enter your search phrase..."} 
              />
              <button className="close-icon" type="reset" onClick={this.handleClick}></button>
            </form>
          </MDBCol>
        </MDBRow>

        {searchQuery &&
        <MDBRow>
          <MDBCol>
            <h2 className="mt-2 mb-5 font-alt font-w-700 text-xs-large text-large text-uppercase text-center">
              Number of results: {queryResults.length}
            </h2>
          </MDBCol>
        </MDBRow>
        }

        {queryResults.length > 0 && 
          <div className="py-5">
            {queryResults.map(item => (
              <Fragment key={item.id}>
                {this.props.context === "blog" ? (
                  <BlogAllItems
                    key={item.id}
                    link={item.slug}
                    title={item.title.replace("<br />", " ")}
                    description={item.subtitle}
                    date={item.date}
                    author={item.category}
                    readtime={item.platform}
                  />
                ) : (
                  <MDBRow key={`row_${item.id}`}>
                    <MDBCol md="1">
                      <CustomLink
                        link={ item.name === 'index' ? '/' : item.name === 'news' ? '/news/' + item.slug + '/' : item.slug }
                        className="ficon-ug d-none d-sm-block"
                      >
                        <FontAwesomeIcon icon={faChevronRight} />
                      </CustomLink>
                    </MDBCol>

                    <MDBCol md="11">
                      <p className="font-alt font-w-400 text-small text-uppercase mb-2">
                        {item.template === 'news' ? item.template + ': ' + moment(item.date).format('MMM DD, YYYY') : item.template.replace(/-/g, " ")}
                      </p>
                      <h3 className="font-alt font-w-700 letter-spacing-1 title-xs-medium title-medium">
                        <CustomLink
                          link={ item.name === 'index' ? '/' : item.name === 'news' ? '/news/' + item.slug + '/' : item.slug }
                          className="effect-noline"
                        >
                          {item.title.replace("<br />", " ")}
                        </CustomLink>
                      </h3>
                      <p className="font-w-400 text-medium">{item.subtitle}</p>

                      <hr className="my-5" />
                    </MDBCol>
                  </MDBRow>
              )}
            </Fragment>
            ))}
          </div>
        }
      </MDBContainer>
    )
  }
}
export default ClientSearch